module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-4.a804b8fd.jpg";